import type { TFunction } from 'i18next';

import { RoleDtoRole } from '@/generated/model';

const roleLabelTranslationKeys: Record<RoleDtoRole, string> = {
  [RoleDtoRole.customerServiceAssistant]: 'userAccessControl.roles.customerServiceAssistant',
  [RoleDtoRole.clientAdministrator]: 'userAccessControl.roles.clientAdministrator',
  [RoleDtoRole.simpleUser]: 'userAccessControl.roles.simpleUser',
};

export function getRoleLabel(t: TFunction, role: RoleDtoRole) {
  return t(roleLabelTranslationKeys[role]);
}
